// Geteilte PM-Konstanten — EINE Quelle fuer Werte, die vorher byte-identisch in beiden Wizards
// dupliziert waren (Drift-Risiko). Die SAP-Codes hier sind DEMO-Customizing; je Kunde kommen sie
// aus der Berater-Matrix in docs/plant-maintenance/sap-contract-requirements.md (§6).

// `key` ist der SAP-Prioritaetscode (PRIOK-Daten); `labelKey` ist der i18n-Key fuer den Anzeigetext.
// Priority 1 was missing until 2026-09-03, which meant the PORTAL could not file the urgency the
// anonymous kiosk already sends ("machine is DOWN" → priority 1) — and the escalation webhook
// defaults to minPriority 2, so the portal could never trigger its own top tier.
// These three/four values are DEMO customizing. op=discover already returns the customer's real
// T356 list; driving the picker from it is the next step and is what makes this list a fallback
// rather than a decision (PM code audit finding 29).
export const PRIORITIES = [
  { key: '4-niedrig', labelKey: 'pm.priority.low' },
  { key: '3-mittel', labelKey: 'pm.priority.mid' },
  { key: '2-hoch', labelKey: 'pm.priority.high' },
  { key: '1-sehr hoch', labelKey: 'pm.priority.veryHigh' },
];

// Schritt-Beschriftungen der 3-Schritt-Wizards (Auftrag UND Meldung teilen denselben Rhythmus).
export const ORDER_STEP_KEYS = ['pm.order.steps.device', 'pm.order.steps.problem', 'pm.order.steps.confirm'];

// SAP-Kurztext (AUFK-KTEXT bzw. QMEL-QMTXT) ist 40 Zeichen — hart begrenzen statt in SAP
// abzuschneiden (sap-contract-requirements.md §3).
export const SAP_SHORT_TEXT_MAX = 40;

// Langtext (Details, Kontraktfeld longText): SAP-Langtexte sind quasi unbegrenzt — die 2000
// sind eine portal-seitige Vernunftgrenze. Diktat landet HIER (nicht im 40-Zeichen-Kurztext).
export const SAP_LONG_TEXT_MAX = 2000;
